export default "__VITE_ASSET__ce2101a0__"